import React, { useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';

function Root() {

    return (
        <BrowserRouter>
            <App />
        </BrowserRouter>
    );
}

const container = document.getElementById('root');
createRoot(container).render(
    <React.StrictMode>
        <Root />
    </React.StrictMode>
);
